import React, { Component } from 'react';
import './Nav.scss'
import { NavLink, withRouter } from 'react-router-dom'

class Nav extends Component {

	state = {
		scroll: false,
		expanded: false,
	}

	componentDidMount() {
		window.addEventListener('scroll', this.scrollEvents, false);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.scrollEvents, false);
	}

	scrollEvents = async (e) => {
		let scroll = window.scrollY > 80 ? true : false
		this.setState({ scroll })
	}
	handleLogo = async ()=> {
		let nav = document.getElementById("nav");
		nav.scrollIntoView({
			behavior: 'smooth'
		});
	}

	render() {
		
		return (
			<div className="header-nav" id="nav">
				<button className={`mobile-button
				 left
				 ${this.state.scroll ? "on-scroll" : "at-top"}
				  ${this.state.expanded ? "expanded" : "not-expanded"}`} onClick={() => this.setState({ expanded: !this.state.expanded })}>
					<i className="fa fa-fw fa-bars"></i>
				</button>
				<a
					href="tel:0897955506"
					onClick={() => window.ga('send', 'event', 'telephone', 'call')}
					className={`mobile-button right ${this.state.expanded ? "expanded" : "not-expanded"}`}>
					<i className="fa fa-fw fa-phone"></i>
				</a>
			<nav
				className={`
				nav
				${this.state.expanded ? "expanded" : "not-expanded"}
				${this.state.scroll ? "active" : "inactive"}
				`}>
				<div className={`overlay`}></div>
				<div className="container-fluid">
					<div className={`row ${this.state.scroll ? "align-items-center" : "align-items-end"}`}>
						<div className="col-lg-4 text-center">
							<NavLink to="/"
								onClick={this.handleLogo}
							>
								<div
									className={`logo 
									${this.state.scroll ? "small" : "large"}
									${this.props.location.pathname === "/" ? "home-page" : "sub-page"}
									`}></div>
							</NavLink>
							</div>
					<div className="col-lg-8 nav-ul-holder">
						<ul>
							<li>
										<NavLink
											to="/"
											exact
											onClick={() => this.setState({ expanded: false })}
										>Home</NavLink>
									</li>
							<li>
								<NavLink to="/what-we-do" onClick={() => this.setState({ expanded: false })}>What we do {/* <div className="fa fa-chevron-down"></div> */}</NavLink>
								{/* <div className="li-dropdown">
									<div className="li-holder">
									<ul>
										<li>
											<a href="#">Test 1</a>
												</li>
												<li>
											<a href="#">Test 2</a>
												</li>
												<li>
											<a href="#">Test 3</a>
										</li>
												</ul>
												</div>
								</div> */}
							</li>
							<li>
								<NavLink to="/what-weve-done" onClick={() => this.setState({ expanded: false })}>What we've done</NavLink>
							</li>
							<li>
								<NavLink to="/the-moshi-difference" onClick={() => this.setState({ expanded: false })}>Moshi Difference</NavLink>
							</li>
							<li>
								<NavLink to="/blog" onClick={() => this.setState({ expanded: false })}>Blog</NavLink>
							</li>
							
							<li>
								<NavLink to="/contact-us" onClick={() => this.setState({ expanded: false })}>Contact</NavLink>
							</li>
						</ul>
						</div>
					</div>
				</div>
				</nav>
			</div>
		);
	}
}

export default withRouter(Nav);


// WEBPACK FOOTER //
// ./src/Layout/Nav.js